// src/utils/apiClient.js
import axios from 'axios';
import { getAuth } from 'firebase/auth'; // Import getAuth from Firebase SDK (client-side)

const API_BASE_URL = 'https://api-5iacy4tfya-uc.a.run.app'; // Your API base URL

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach the Firebase ID token
apiClient.interceptors.request.use(async (config) => {
  const auth = getAuth(); // Get the Firebase Auth instance
  const user = auth.currentUser; // Get the current authenticated user

  if (user) {
    try {
      const idToken = await user.getIdToken(true); // Force refresh the token
      config.headers.Authorization = `Bearer ${idToken}`;
    } catch (error) {
      console.error("Error getting Firebase ID token:", error);
      // If token acquisition fails, it's usually because the user is logged out or session expired.
      // You might want to clear local storage, redirect to login, etc.
      // For now, we'll let the request proceed without a token, which will likely result in a 401.
    }
  } else {
      console.warn("No Firebase user found. API request will be unauthenticated.");
      // If no user, ensure Authorization header is NOT sent, or remove it if it was set previously.
      delete config.headers.Authorization;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Optional: Response interceptor for error handling (e.g., redirect on 401)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.error("Unauthorized request. User might need to re-authenticate.");
            // Example: Redirect to login page or show a toast
            // window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default apiClient;